import React from 'react'
import Label from '../../ui/Label'
import Input from '../../ui/Input'
import DropdownBtn from '../../ui/DropdownBtn'
import { selectCreateNewStaff, selectTypeOfOpen, setTypeOfOpen, updateCreateNewStaffField } from '../../../features/user/userSlice'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentModalType } from '../../../features/modal/modalSlice'
import { CreateNewStaffState, RoleType, StatusType } from '../../../types/user'
import Loading from '../../ui/Loading'
import { useStaffMeta } from '../../../hooks/useStaffMeta'
import { useMutationData } from '../../../hooks/api/useMutationData'
import StaffModalHeader from '../../common/headers/StaffModalHeader'
import RoleList from '../../common/RoleList'
import StatusList from '../../common/StatusList'
import useUserAction from '../../../hooks/actions/useUserAction'
import { defaultOptionRole, defaultOptionStatus } from '../../../constant/default'

export default function StaffModal() {

    const dispatch = useDispatch();
    const typeModal = useSelector(selectCurrentModalType);
    const createNewStaffState = useSelector(selectCreateNewStaff);
    const typeOfOpenList = useSelector(selectTypeOfOpen)
    const { isLoadingCreatingNewStaff, isLoadingUpdateStaff } = useMutationData()
    const { handleSaveNewStaff } = useUserAction()
    const { roleOptions, statusOptions } = useStaffMeta();
    const roleList: RoleType[] = typeModal === "updateStaff" ? roleOptions : [defaultOptionRole, ...roleOptions];
    const statusList: StatusType[] = typeModal === "updateStaff" ? statusOptions : [defaultOptionStatus, ...statusOptions];
    
    // const { userInfo } = useQueryData()
    // const { data: userInfo, isError: isErrorUserInfo, error: errorUserInfo, isLoading: isLoadingUserInfo, refetch: refetchUserInfo, isFetching: isFetchingUserInfo } = useGetInfoByStaffIdQuery(selectedCurrentStaffId ?? skipToken);
    // const { roles, status } = useStaffMeta();
    // const { populateStaffInfo } = useStaffPopulate(userInfo, roles, status);

    // useEffect(() => {
    //     if (typeModal !== "updateStaff") return;
    //     if (!userInfo) return;

    //     populateStaffInfo();
    // }, [userInfo]);

    const isSubmitDisabled = !createNewStaffState?.firstName ||
        !createNewStaffState?.lastName ||
        !createNewStaffState?.email ||
        !createNewStaffState?.role ||
        (typeModal === 'newStaff' && !createNewStaffState?.password) ||
        (typeModal === 'updateStaff' && !createNewStaffState?.status);

    const handleChangeNewStaff = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        dispatch(updateCreateNewStaffField({ field: name as keyof CreateNewStaffState, value }));
    }

    const loadingMessage = typeModal === 'newStaff' ? 'Saving New Staff...' : 'Updating Staff...'

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <StaffModalHeader/>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='pt-2 space-y-3'>
                            <div className='grid grid-cols-2 gap-3'>
                                <div className=''>
                                    <Label label={'First Name *'}/>
                                    <Input  
                                        name='firstName'
                                        type={'text'}
                                        value={createNewStaffState?.firstName ?? ''}
                                        onChange={handleChangeNewStaff}
                                        placeholder={'Juan'}
                                        required
                                        textSize='text-xs'
                                    />
                                </div>
                                <div className=''>
                                    <Label label={'Middle Name'}/>
                                    <Input
                                        name='middleInitial'
                                        type={'text'}
                                        value={createNewStaffState?.middleInitial ?? ''}
                                        onChange={handleChangeNewStaff}
                                        placeholder={'D'}
                                        maxLength={1}
                                        upperCase={'uppercase'}
                                        required
                                        textSize='text-xs'
                                    />
                                </div>
                                <div className=''>
                                    <Label label={'Last Name *'}/>
                                    <Input
                                        name='lastName'
                                        type={'text'}
                                        value={createNewStaffState?.lastName ?? ''}
                                        onChange={handleChangeNewStaff}
                                        placeholder={'Dela Cruz'}
                                        required
                                        textSize='text-xs'
                                    />
                                </div>
                                <div className=''>
                                    <Label label={'Email *'}/>
                                    <Input
                                        name='email'
                                        type={'email'}
                                        value={createNewStaffState?.email ?? ''}
                                        onChange={handleChangeNewStaff}
                                        placeholder={'example@gmail.com'}
                                        required
                                        textSize='text-xs'
                                    />
                                </div>
                                <div className=''>
                                    <Label label={'Role *'}/>
                                    <div className='relative inline-block h-auto w-full'>
                                        <div className='w-full h-auto'>
                                            <DropdownBtn
                                                label={createNewStaffState?.role?.role ?? defaultOptionRole.role}
                                                isOpen={typeOfOpenList === 'role'}
                                                onClick={() => dispatch(setTypeOfOpen(typeOfOpenList === "role" ? null : "role"))}
                                                isCustomClass={true}
                                                customClass={'flex w-full text-xs justify-between items-center font-medium rounded transition px-4  text-black py-2 space-x-2 text-sm  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                                            />
                                            {typeOfOpenList === 'role' && (
                                                <RoleList roleList={roleList} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {typeModal === 'newStaff' && (
                                    <div className=''>
                                        <Label label={'Password *'}/>
                                        <Input
                                            name='password'
                                            type={'text'}
                                            value={createNewStaffState?.password ?? ''}
                                            onChange={handleChangeNewStaff}
                                            maxLength={6}
                                            required
                                        />
                                    </div>
                                )}
                                {typeModal === 'updateStaff' && (
                                    <div className=''>
                                        <Label label={'Status *'}/>
                                        <div className='relative inline-block h-auto w-full'>
                                            <div className='w-full h-auto'>
                                                <DropdownBtn
                                                    label={createNewStaffState?.status?.status ?? ""}
                                                    isOpen={typeOfOpenList === 'status'}
                                                    onClick={() => dispatch(setTypeOfOpen(typeOfOpenList === "status" ? null : "status"))}
                                                    isCustomClass={true}
                                                    customClass={'flex w-full justify-between items-center font-medium rounded transition px-4  text-black py-2 space-x-2 text-sm  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                                                />
                                                {typeOfOpenList === 'status' && (
                                                    <StatusList statusList={statusList} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <button 
                                onClick={handleSaveNewStaff}
                                disabled={ isSubmitDisabled || isLoadingCreatingNewStaff || isLoadingUpdateStaff}
                                className={`w-full text-xs px-4 py-2 rounded font-medium transition-all ${isSubmitDisabled || isLoadingCreatingNewStaff || isLoadingUpdateStaff ? 'cursor-not-allowed bg-gray-200 border text-black' : 'bg-cbColor text-white'}`}
                            >
                                {isLoadingCreatingNewStaff || isLoadingUpdateStaff ? (
                                    <Loading setH={'h-[20px]'}  message={loadingMessage}/>
                                ) : (
                                    <>
                                        {typeModal === 'newStaff' && 'Save New Staff'}
                                        {typeModal === 'updateStaff' && 'Save Update Staff'}
                                    </>
                                )}
                            </button>
                        </div>       
                    </div>
                </div>
            </div>
        </div>
    )
}
